import React from "react";
import { connect } from "react-redux";
import ReactHtmlParser from "react-html-parser";
import Helpers from "../../helpers/AssetHelpers.js";
import * as bioActions from "../../actions/bio";

class About extends React.Component {
  componentDidMount() {
    this.props.dispatch(bioActions.loadBio());
  }

  render() {
    const { bio, error } = this.props.bio;
    const loading = this.props.loading;

    if (loading.loading) {
      return <section id="about" ref={this.props.innerRef} />;
    }
    if (error) {
      return "error";
    }

    return (
      <section id="about" ref={this.props.innerRef}>
        <div className="row">
          <div className="five columns">
            <img
              className="profile-pic"
              src={Helpers.imagePath("about.jpg")}
              alt=""
            />
          </div>
          <div className="seven columns main-col">
            <p>
              {bio &&
                ReactHtmlParser(
                  bio.filter(item => item.name === "bio")[0].content
                )}
            </p>
            <h3>When I'm not working, I'm likely: </h3>
            <ul className="list">
              <li>going for hikes</li>
              <li>fishing</li>
              <li>snorkeling</li>
              <li>listening to music</li>
              <li>...but more than likely chauffeuring a kid around</li>
            </ul>
          </div>
        </div>
      </section>
    );
  }
}

const mapStateToProps = state => ({
  ...state,
  work: state.work.work,
  bio: state.bio
});

export default connect(mapStateToProps, null, null, { withRef: true })(About);



// WEBPACK FOOTER //
// ./src/components/About/About.js